'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = void 0;
var isfastmode = function () {
        return function () {
            var e = 1;
            try {
                localStorage.setItem('checkfastmode', 1), e = 0;
            } catch (e) {
                console.error(e);
            }
            return e;
        }();
    }, setSession = function (e, t) {
        if (isfastmode())
            return '';
        sessionStorage.setItem(e, JSON.stringify(t));
    }, getSession = function (e) {
        return isfastmode() ? '' : JSON.parse(sessionStorage.getItem(e)) || '';
    }, setlocal = function (e, t) {
        if (isfastmode())
            return '';
        localStorage.setItem(e, JSON.stringify(t));
    }, getlocal = function (e) {
        return isfastmode() ? '' : JSON.parse(localStorage.getItem(e));
    }, _default = {
        setSession: setSession,
        getSession: getSession,
        setlocal: setlocal,
        getlocal: getlocal,
        isfastmode: isfastmode
    };
exports.default = _default;